<template>
  <div class="tableBtn">
    <b-button id="editBtn" pill size="sm" @click="onClick"
      ><slot><i class="bi bi-pencil-fill icon editBtnIcon"></i></slot
    ></b-button>
  </div>
</template>

<script>
export default {
  name: 'EditButton',
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-color: white;

.editBtnIcon {
  font-size: 16px;
  color: $icon-color;
}
</style>
